import { theme } from '@approvalmax/theme';
import styled from 'styled-components';

export const Content = styled.div`
    background-color: ${theme.color.white100};
    min-width: 300px;
    max-width: 680px;
    max-height: 170px;
`;
